import React from "react";
import { Button, Table } from "react-bootstrap";
import { AppContext } from "../../AppContext.js";
import { isEmpty, isEmptyArray } from "../../gui_components/Util.js";
import { EntityLockBean, PageListBean,RestReadRequest } from "./../../ds/ds.js";
import { DeleteIcon } from "./../../gui_components/Icons.js";
import { ShowError } from "./../../gui_components/UIComponents.js";
import { EntityLockService } from "./../../services/EntityLockService.js";
import { BaseInquiryToolBar } from "./../BaseModule.js";

class ReleaseLockList extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "Release Lock",
      pageList: new PageListBean(),
      lockBean: new EntityLockBean(),
      isLoading: false,
      isShowClearCriteriaButton: true,
      isShowClearErrorButton: false,
      isShowResetButton: true,
      //changed nov 29
      isShowAutoRefreshToggleButton: true,
      
      //end
      entityLockList: [],
      isShowExitButton: true,
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;

    this.sessionBean = JSON.parse(localStorage.getItem("session"));
    this.loadReleaseLockPage();
  }

  moduleExit = () => {
    this.props.onModuleExit();
  };

  loadReleaseLockPageResponse = (response) => {
    if (
      !isEmpty(response) &&
      !isEmpty(response.data) &&
      !isEmpty(response.data.entityLockPageList) &&
      !isEmptyArray(response.data.entityLockPageList.entityLocks)
    ) {
      const lockList = response.data.entityLockPageList.entityLocks;
      let loading = false;
      this.setState({
        isLoading: loading,
        entityLockList: lockList,
      });
    } else {
      this.setState({
        isLoading: false,
        entityLockList: new Array(),
      });
    }
  };
  loadReleaseLockPageError = (error) => {
    ShowError("Error : " + error);
  };
  loadReleaseLockPage = () => {
    let loading = true;
    this.setState({ isLoading: loading });
    //this.method("getEntityLockList_v1", input, responseCallBack, errorCallBack);
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    EntityLockService.getEntityLockList_v1(
      input,
      this.loadReleaseLockPageResponse,
      this.loadReleaseLockPageError
    );
  };
  releaseLockData = (val, rowData) => {
    let lockBean = new EntityLockBean();
    lockBean.companyCode = this.companyCode;
    lockBean = rowData;
    EntityLockService.releaseLock(
      lockBean,
      this.releaseEntityLockPageResponse,
      this.releaseEntityLockPageError
    );
  };
  releaseEntityLockPageResponse = (response) => {
    if (response.data != null) {
      this.setState({
        isLoading: true,
      });
      this.reloadEntityList();
    }
  };
  releaseEntityLockPageError = (error) => {
    ShowError("Error : " + error);
  };
  reloadEntityList = () => {
    this.loadReleaseLockPage();
  };

  autoRefreshExecute = () => {
    this.reloadEntityList();
  }

  render() {
    let entityLockList = new Array();
    if (!isEmptyArray(this.state.entityLockList))
      entityLockList = this.state.entityLockList;
    let isLoading = this.state.isLoading;
    
    return (
      <div>
        <BaseInquiryToolBar
          pageTitle={this.state.pageTitle}
          clearCriteria={this.clearCriteria}
          clearError={this.clearError}
          isShowResetButton={this.state.isShowResetButton}
          
          reset={this.reloadEntityList}
          autoRefreshExecute={this.autoRefreshExecute}
         
          onModuleExit={() => this.moduleExit()}
          isShowAutoRefreshToggleButton={this.state.isShowAutoRefreshToggleButton}
          isLoading={isLoading}
          isShowExitButton={this.state.isShowExitButton}
        />
        <div className="div_long">
          <Table id="fabrics_tables_default">
            <thead>
              <tr>
                <th> EntityCode </th>
                <th> EntityType </th>
                <th> Locked By </th>
                <th> Locked On </th>
                <th> Release </th>
              </tr>
            </thead>
            <tbody>
              {entityLockList.map((list, i) => (
                <tr key={i}>
                  <td>{list.code}</td>
                  <td>{list.lockTypeName}</td>
                  <td>{list.createdBy}</td>
                  <td>{list.createdDate}</td>
                  <td className="text-center">
                    <Button
                      onClick={() => this.releaseLockData(list.code, list)}
                    >
                      <DeleteIcon />
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          {entityLockList.length != 0 ? null : (
            <div className="no_Data">{"NO DATA"}</div>
          )}
        </div>
      </div>
    );
  }
}
function ReleaseLockModule(props) {
  return (
    <div id="moduleContainer" class="module_container">
      <div id="app_container"></div>
      <ReleaseLockList {...props} name="" /> <br />
    </div>
  );
}

export default ReleaseLockModule;
